


























import { Component, Prop, Vue } from 'vue-property-decorator';
import Equation from '@/components/Equation.vue';
import { StallSpeedConstraint } from '@/interfaces/constraints';

@Component({
  components: {
  Equation,
  }
  })
export default class StallSpeedFields extends Vue {
  @Prop() constraint!: StallSpeedConstraint;
}
